import {Component, OnInit} from "@angular/core";
import {CloudApiService} from "../../services/cloud-api.service";
import {NgbPopoverConfig} from "@ng-bootstrap/ng-bootstrap";
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: 'totes',
    template: require('./totes.component.html'),
    styles: [ require('./totes.component.css') ],
    providers: [NgbPopoverConfig]
})

export class TotesComponent implements OnInit {
    constructor(private cloudApiService: CloudApiService, private route: ActivatedRoute,
    ){
    }

    ngOnInit(): void {
        let returnUrl = this.route.snapshot.paramMap.get('returnUrl');
        location.assign(this.cloudApiService.getRelativeUrl(`app/tote/#${returnUrl == undefined ? '/' : returnUrl}`));
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/components/totes/totes.component.ts